import { render, staticRenderFns } from "./settleOrder.vue?vue&type=template&id=a96fe018&scoped=true&"
import script from "./settleOrder.vue?vue&type=script&lang=js&"
export * from "./settleOrder.vue?vue&type=script&lang=js&"
import style0 from "./settleOrder.vue?vue&type=style&index=0&id=a96fe018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96fe018",
  null
  
)

export default component.exports